export const rulesMeta = {
  title: "Tournament Rules",
  subtitle: "Legends Poker adopts the 2026 Poker TDA Rules, Recommended Procedures and Illustration Addendum, as amended by Legends Poker.",
  disclaimer: "The following is a summary. This summary is provided for convenience only. Players should refer to the full TDA Rules as amended by Legends Poker for complete details and interpretations.",
  docPdf: "/docs/2026-Poker-TDA-Rules-Legends-Poker.pdf",
};

export const rulesSections = [
  { id: "general", title: "General", list: [
    "Players must be 18 years or older with valid ID.",
    "The Tournament Director's decision is final in all disputes.",
    "English-only at the table during hands.",
  ] },
  { id: "betting-raising", title: "Betting & Raising", list: [
    "The minimum opening bet is the big blind.",
    "A raise must be at least the size of the big blind and at least the size of the opening bet or previous full raise of the current betting round.",
    "A player who raises 50% or more of the largest prior bet but less than a minimum raise must make a full minimum raise. If less than 50% it is a call unless “raise” is first declared.",
    "Pushing out one oversized chip without saying “raise” is a call when facing a bet, and a full-value bet when not facing a bet. If an unspecified raise is declared, it will be the full value of the chip.",
    "A short all-in is called as a full bet or raise.",
    "A short all-in, or multiple short all-ins totalling less than a full raise, does not reopen betting for players who have already acted.",
    "Verbal declarations in turn are binding.",
    "It is the player’s responsibility to know the bet before calling.",
    "No string betting.",
    "Straddles are not live.",
  ] },
  { id: "action-etiquette", title: "Action & Etiquette", list: [
    "Out-of-turn action is binding unless action changes before it returns to the player; out-of-turn folds are always binding.",
    "In heads-up play, a player who checks out of turn may only call or fold if facing a bet on that round.",
    "During a live hand, players must not show or discuss contents of live or mucked hands, advise or criticize play at any time, or read a hand that hasn't been tabled.",
    "No angle shooting.",
    "Exposing cards with action pending, including the current player when last to act, may result in a penalty but not a dead hand.",
    "No collusion or soft play.",
    "Show one/show all.",
    "No splashing the pot.",
    "Stalling or persistent delays not allowed.",
  ] },
  { id: "live-hands", title: "Live Hands & Player Responsibilities", list: [
    "To have a live hand, players must be within reach of their seats when the last card is dealt to all players; posted blinds and antes forfeit to the pot.",
    "Players are responsible for protecting their own hands.",
    "Cards must remain on the table, and live hands must not be concealed.",
  ] },
  { id: "showdown", title: "Showdown", list: [
    "All-in hands must be tabled once all betting is complete. Any player who is all-in or has called all action cannot muck and must show their cards.",
    "To win a showdown, your entire hand must be properly tabled, even if playing the board.",
  ] },
  { id: "tournament-procedures", title: "Tournament Procedures", list: [
    "A new level begins upon floor announcement or audio signal by the tournament clocking system. The new betting limits apply to the next hand.",
    "Hands begin on the dealer cut of the deck.",
  ] },
  { id: "dealing-misdeals", title: "Dealing & Misdeals", groups: [
    { h: "Misdeal", list: [
      "Two or more boxed or exposed cards on the initial deal.",
      "The first card is dealt to the wrong seat.",
      "Cards dealt to an ineligible seat.",
      "An eligible seat is dealt out.",
      "Any player receives the wrong number of cards.",
      "One of the first two cards is boxed or exposed by dealer error.",
    ] },
    { h: "Board & Burn Card Errors", list: [
      "If any later-dealt card past the first two seats is boxed or exposed through dealer error, it becomes the burn card, and the affected player receives the last card off the deck.",
      "Premature board or street cards are returned to the stub, the stub is reshuffled, and the street is re-dealt without an additional burn.",
      "If the dealer forgets to burn, fix it if no action has occurred, let it stand if any action has occurred.",
    ] },
  ] },
  { id: "pot-management", title: "Pot Management", list: [
    "Only the dealer should handle the pot. No change should be made from the pot, nor should any bets be pulled in, until the betting round is complete.",
  ] },
];
